import { poTemplateSchema } from "@redotech/redo-model/purchase-order-document";
import * as z from "zod/v4";

export const getPoTemplates = {
  name: "getPoTemplates" as const,
  input: z.object({}),
  output: z.array(poTemplateSchema),
};
